import { RestLayoutService } from '@sitecore-jss/sitecore-jss-vue';
import config from '../temp/config';

export class LayoutServiceFactory {
  create(apiHost, siteName) {
    return new RestLayoutService({
      apiHost: apiHost ?? config.sitecoreApiHost,
      apiKey: config.sitecoreApiKey,
      siteName: siteName ?? config.jssAppName,
      configurationName: 'default',
      tracking: false,
    });
  }
}

export const layoutServiceFactory = new LayoutServiceFactory();
